// extracted by mini-css-extract-plugin
export default {"buttonMuiOverride":"PrimaryButton_buttonMuiOverride__tAN57","arrow":"PrimaryButton_arrow__6yM6I","textIconContainer":"PrimaryButton_textIconContainer__RXOem"};